var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntransitNoQuoteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 73,
    viewBox: "0 0 100 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7669 18.359H35.415V55.7828H1.58467V38.9384L5.53022 25.3021C6.71957 21.19 10.486 18.359 14.7669 18.359Z",
    fill: "#0067E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52228 38.7657L10.0386 26.6105C10.6448 24.5211 12.5883 23.0587 14.7653 23.0587H30.7139V38.7657H6.52228Z",
    fill: "#84DBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5176 38.7597H30.7217V23.0527L6.5176 38.7597Z",
    fill: "#CDD6E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52228 38.7657L10.0386 26.6105C10.6448 24.5211 12.5883 23.0587 14.7653 23.0587H30.7139L6.52228 38.7657Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7506 0H41.6636C38.2139 0 35.4142 2.7976 35.4142 6.24944V56.2096H100V6.24944C100 2.7978 97.2024 0 93.7506 0Z",
    fill: "#CEE4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000167847 55.7787V62.8405H99.9912V55.7787H89.5546C87.1174 51.4041 82.4303 48.4459 77.0558 48.4459C71.7021 48.4459 67.0151 51.4041 64.5569 55.7787H30.9765C28.5392 51.4041 23.875 48.4459 18.5005 48.4459C13.1259 48.4459 8.45976 51.4041 6.00159 55.7787H0.000167847Z",
    fill: "#334A5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51995 62.797C8.51995 68.309 12.9883 72.7774 18.5003 72.7774C24.0123 72.7774 28.4766 68.309 28.4766 62.797C28.4766 57.285 24.0104 52.8167 18.5003 52.8167C12.9861 52.8167 8.51995 57.285 8.51995 62.797Z",
    fill: "#40596B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4886 62.7967C14.4886 65.0112 16.2843 66.8048 18.4966 66.8048C20.7111 66.8048 22.5088 65.0112 22.5088 62.7967C22.5088 60.5823 20.7131 58.7887 18.4966 58.7887C16.2843 58.7867 14.4886 60.5825 14.4886 62.7967Z",
    fill: "#ACB3BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0861 62.797C67.0861 68.309 71.5566 72.7774 77.0665 72.7774C82.5785 72.7774 87.0469 68.309 87.0469 62.797C87.0469 57.285 82.5785 52.8167 77.0665 52.8167C71.5566 52.8167 67.0861 57.285 67.0861 62.797Z",
    fill: "#40596B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0572 62.7967C73.0572 65.0112 74.8507 66.8048 77.0652 66.8048C79.2797 66.8048 81.0752 65.0112 81.0752 62.7967C81.0752 60.5823 79.2795 58.7887 77.0652 58.7887C74.8509 58.7887 73.0572 60.5825 73.0572 62.7967Z",
    fill: "#ACB3BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntransitNoQuoteLogo);
export default __webpack_public_path__ + "static/media/intransitNoQuoteLogo.0fc58291665465900e8d60a3bd6c945c.svg";
export { ForwardRef as ReactComponent };